import React from 'react';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';

import { BigTitle, BodyText, Caption } from '@/components';

function LandingInvestConditions({ setOpen }) {
  const navigate = useNavigate();
  const handleNavigateToSteps = () => {
    navigate('/deposit-card/apply');
  };

  const location = window.location.host;

  return (
    <div tw='sm:py-20 py-14 bg-secondary sm:px-5'>
      <div tw='max-w-app mx-auto'>
        <BigTitle text={'Условия и тарифы'} twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`} />

        <table tw='min-w-full divide-y divide-grey my-5'>
          <tbody tw='divide-y divide-grey '>
            <tr>
              <td tw='p-5 bg-[#444444] rounded-t-2xl align-top '>Вид карты</td>
              <td tw='font-bold p-5'>
                Mastercard World
                <br />
                <Caption text={<span>пластиковая, цифрового аналога нет</span>} twStyle={tw`text-secondary`} />
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top '>Валюта </td>
              <td tw='font-bold p-5'>тенге, доллары, евро и рубли</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Срок действия</td>
              <td tw='font-bold p-5'>до 12 месяцев</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Выпуск</td>
              <td tw='font-bold p-5 '>0 ₸</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Доставка</td>
              <td tw='font-bold p-5 text-justify'>
                Комиссия за выпуск и доставку пластиковой карты составляет 20 000 тенге (или эквивалент в другой валюте)
                и будет списана с вашей платежной карты. В случае отказа от доставки комиссия не возвращается.
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Пополнение</td>
              <td tw='font-bold p-5'>бесплатно</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Снятие наличных</td>
              <td tw='font-bold p-5 text-justify'>
                до 1 050 $ в календарный месяц - бесплатно; свыше 1 050 $ в календарный месяц - 3% от суммы + 500 тг за
                каждое снятие * - акционный тариф
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Переводы внутри банка</td>
              <td tw='font-bold p-5 text-justify'>
                до 4 000 000 тенге в календарный месяц (или эквивалент в другой валюте) – 0, свыше 4 000 000 тенге в
                календарный месяц - 3% * - акционный тариф
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Переводы на карты других банков</td>
              <td tw='font-bold p-5 text-justify'>
                до 1 050 $ в календарный месяц - бесплатно; свыше 1 050 $ в календарный месяц - 0,5% от суммы + 500 тг
                за каждый перевод * - акционный тариф
              </td>
            </tr>

            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Конвертации</td>
              <td tw='font-bold p-5'>бесплатно</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>SMS-информирование</td>
              <td tw='font-bold p-5'>бесплатно</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Максимальная сумма перевода c карты на карту</td>
              <td tw='font-bold p-5'>5 000 долларов за один раз</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444]  rounded-b-2xl align-top'>Максимальная сумма всех переводов с карты на карту</td>
              <td tw='font-bold p-5'>100 000 долларов в месяц</td>
            </tr>
          </tbody>
        </table>
        <BodyText text={'* Акционный тариф, действует до 31.12.2025г.'} twStyle={tw`text-secondary text-sm`} />
        <br />
        <BodyText text={'** не подлежит изменению'} twStyle={tw`text-secondary text-sm`} />
        <div tw='flex gap-2 cursor-pointer my-5'>
          <a
            href='https://bankffin.kz/docs/invest-card-fiz_ru.pdf?v0.5'
            target={'_blank'}
            tw='border-b divide-y'
            rel='noreferrer'
          >
            Полный список тарифов по карте
          </a>
          <span tw='bg-[#484444] rounded-xl px-2 h-[25px]'>PDF</span>
        </div>
      </div>
    </div>
  );
}

export default LandingInvestConditions;
